<script type="ts">
  import ThemeToggle from "./ThemeToggle.svelte";

  const getRandomLogo = () => {
    const possibleLogos = ["♣️", "♦️", "♥️", "♠️"];
    const random = Math.floor(Math.random() * possibleLogos.length);
    return possibleLogos[random];
  };
</script>

<div class="sticky top-0 z-30 navbar bg-base-200">
  <div class="flex-1">
    <a class="text-2xl normal-case btn btn-ghost text-neutral" href="/">
      <p class="text-primary">{getRandomLogo()} Cambio</p>
      <p class="dark:text-gray-400">Scoreboard</p>
    </a>
  </div>
  <div class="flex-none px-4">
    <ThemeToggle />
  </div>
</div>
